import React from 'react';
import { IconChevronRight } from '@spotify-internal/encore-web';
import styled from 'styled-components';

interface ChevronIconProps {
  size?: 16 | 24 | 32 | 48 | 64;
}

const addFlexNoShrink = (component: typeof IconChevronRight) => styled(component)`
  display: flex;
  flex-shrink: 0;
`;
const StyledIconChevronRight = addFlexNoShrink(IconChevronRight);

const ChevronIcon = ({ size }: ChevronIconProps) => <StyledIconChevronRight iconSize={size} aria-hidden="true" />;

export default ChevronIcon;
